<template>
  <!-- 表单信息 -->
  <div class="mt8 formData">
    <van-form @submit.prevent="onSubmit" ref="dataForms" :disabled="isDisabled">
      <div class="modulesWrap">
        <div class="cardWrap">
          <div class="cardTitle">基础信息</div>
        </div>
        <template class="everyForm">
          <van-field label="性别" required clickable label-width="80px" :rules="[{ required: true }]">
            <template #input>
              <van-radio-group v-model="dataForm.gender" direction="horizontal" :rules="[{ required: true}]"  :disabled="dataForm.identityType == 1">
                <van-radio checked-color="#ee0a24" v-for="item in xbList" :name="item.value" :key="item.value">{{ item.name }}</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </template>
        <template class="everyForm">
          <van-field clickable readonly label="出生日期" label-width="80px">
            <template #input>
              <span v-if="dataForm.identityType == 1">{{ dataForm.birthDate }}</span>
              <template v-else>
                <van-cell :border="false" :value="dataForm.birthDate || '请选择出生日期'" @click ="birthDataShow = true"/>
                <van-popup v-model="birthDataShow" position="bottom">
                  <van-datetime-picker
                    @cancel="birthDataShowCancel"
                    @confirm="onBirthDateConfirm"
                    v-model="dataForm.birthDateValue"
                    :min-date="minDate"
                    :max-date="maxDate"
                    type="date"
                    title="请选择出生日期"
                  />
                </van-popup>
              </template>
            </template>
          </van-field>
        </template>
        <template class="everyForm">
          <van-field readonly clickable label-width="80px" required v-model="dataForm.nationName" label="民族"
            right-icon="arrow-down" input-align="right" placeholder="请选择民族" :rules="[{ required: true }]"
            @click="nationShow = true" />
          <van-popup v-model="nationShow" position="bottom">
            <van-picker show-toolbar :columns="mzList" value-key="name" @confirm="nationConfirm"
              @cancel="nationShow = false" />
          </van-popup>
        </template>
        <template class="everyForm">
          <van-field readonly clickable label-width="80px" required v-model="dataForm.politicalStatusName" label="政治面貌"
            right-icon="arrow-down" input-align="right" placeholder="请选择政治面貌" :rules="[{ required: true }]"
            @click="politicalStatusShow = true" />
          <van-popup v-model="politicalStatusShow" position="bottom">
            <van-picker show-toolbar :columns="zzmmList" value-key="name" @confirm="politicalStatusConfirm"
              @cancel="politicalStatusShow = false" />
          </van-popup>
        </template>  
        <template class="everyForm">
          <van-field readonly clickable label-width="80px" required v-model="dataForm.ancestralNativeTypeName" label="户口性质"
            right-icon="arrow-down" input-align="right" placeholder="请选择户口性质" :rules="[{ required: true }]"
            @click ="ancestralNativeTypeShow = true" />
          <van-popup v-model="ancestralNativeTypeShow" position="bottom">
            <van-picker show-toolbar :columns="hkxzList" value-key="name" @confirm="ancestralNativeTypeConfirm"
              @cancel="ancestralNativeTypeShow = false" />  
          </van-popup>
        </template>  
        <!-- <template class="everyForm">
          <van-field
            v-model="residentValue"
            is-link
            readonly
            label="籍贯"
            required
            placeholder="请选择省、市"
            @click="residentShow = true"
            :rules="[{ required: true }]"
          />
          <van-popup v-model="residentShow" round position="bottom">
            <van-cascader
              v-model="dataForm.resident"
              title="省、市"
              :options="provinceList"
              :field-names="fieldNames"
              @close="residentShow = false"
              @change="(e)=>{addressChange(e,'resident')}" 
              @finish="(e)=>{addressFinish(e,'resident')}"
            />
          </van-popup>
        </template> -->

        <template class="everyForm">
          <van-field
            v-model="fieldValue"
            is-link
            readonly
            label="通信地址"
            required
            placeholder="省、市、区县、乡镇街道"
            @click="addressShow = true"
            :rules="[{ required: true }]"/>
          <van-popup v-model="addressShow" round position="bottom">
            <van-cascader
              v-model="dataForm.address"
              title="省、市、区县、乡镇街道"
              :options="provinceList"
              :field-names="fieldNames"
              @close="addressShow = false"
              @change="(e)=>{addressChange(e,'address')}" 
              @finish="(e)=>{addressFinish(e,'address')}"
            />
          </van-popup>
        </template>
        <template class="everyForm">
          <van-field label-width="80px" required :border="false" v-model.trim="dataForm.communicationDetailedAddress" :rules="[{ required: true }]" label="详细地址" placeholder="详细地址" />
        </template>
      </div>
      <div class="modulesWrap">
        <div class="cardWrap">
          <div class="cardTitle">证照信息</div>
        </div> 
        <div class="everyForm">
          <van-field name="slider" readonly clickable label="个人证件照" label-width="80px" v-model.trim="dataForm.photo" >
            <template #input>
              <van-cell @click="goPersonalPhoto" is-link :value="dataForm.photo ? '已制作' : '去制作'" :border="false" class="myCell"/>
            </template> 
          </van-field>
        </div>  
        <template class="everyForm">
          <van-field name="slider" readonly clickable :border="false" required label="身份证正反面" label-width="80px" v-model.trim="dataForm.identityCardBack" :rules="[{ required: true }]">
            <template #input>
              <van-cell @click ="goFrontBackIdCard" is-link :value="dataForm.identityCardBack ? '已上传':'去上传'" :border="false" class="myCell"/>
            </template>
          </van-field>
        </template>
      </div>
      <div class="modulesWrap">
        <div class="cardWrap">
          <div class="cardTitle">工作学习经历</div>
        </div>
        <template class="everyForm">
          <van-field name="slider" readonly clickable required label="前置学历证书电子版" label-width="80px" v-model.trim="dataForm.preposeDiploma" :rules="[{ required: true }]">
            <template #input>
              <van-cell @click ="goPreposeDiploma" is-link :value="dataForm.preposeDiploma ? '已上传': '去上传'" :border="false" class="myCell"/>
            </template> 
          </van-field>
        </template>  
        <template class="everyForm">
          <van-field label-width="80px" required v-model.trim="dataForm.oldGraduated" label="毕业院校" :rules="[{ required: true }]" placeholder="请与证书上保持一致"/>
        </template>
        <template class="everyForm">
          <van-field name="slider" :border="false" readonly clickable :required="isRequireWorkCertificate" label="工作证明" label-width="80px" v-model.trim="dataForm.workCertificate" :rules="[{ required: isRequireWorkCertificate }]"> 
            <template #input>
              <van-cell @click ="goWorkCertificate" is-link :value="dataForm.workCertificate ? '已上传': '去上传'"  :border="false" class="myCell"/>
            </template>
          </van-field>
          <p class="prompt">注: 报读中药、药剂、化学工艺专业的必填</p>
        </template>
      </div>
      <!-- <div class="next">
        <van-button type="info" block round class="nextBtn" native-type="submit">下一步</van-button>
      </div> -->
    </van-form>
  </div>
</template>
<script>
import { Toast  } from 'vant';
import  {getStudentInfo} from '@/api/login'
import {admindivisionFirstList,admindivisionNextList,saveData,getSpecialty} from '@/api/home' // 省份及下级

export default {
  name: "homes",
  data() {
    return {
      xbList: [{name: '女',value: '1'},{name: '男',value: '0'}], // 性别
      mzList: [], // 民族
      zzmmList: [], // 政治面貌
      hkxzList: [], // 户口性质
      provinceList: [], // 省份
      zymctsList: [], // 特殊专业
      isRequireWorkCertificate: false, // 是否必传工作
      residentValue: '', // 籍贯
      fieldValue: '', // 省市区
      birthDateValue: new Date(), // 出生日期 
      maxDate: new Date(),
      minDate: new Date(1911, 0, 1),
      fieldNames: {
        text: 'areaName',
        value: 'areaCode',
        children: 'children',
      },
      dataForm: {
        gender: '', // 性别
        birthDate: '', //   出生日期
        nation: '', //  民族 
        nationName: '', // 名族名称
        politicalStatus: '', //  政治面貌
        politicalStatusName: '', //  政治面貌名称
        ancestralNativeType: '', // 户口性质  
        ancestralNativeTypeName: '', // 户口性质名称
        residentProvince: '', // 户籍省
        residentPrefecturalCity: '', // 户籍市
        communicationProvince: '', // 通讯地址省份
        communicationPrefecturalCity: '', // 通讯地址城市
        communicationGroundArea: '', // 通讯地址城市
        communicationStreet: '', // 通讯地址街道
        communicationDetailedAddress: '', // identityTypeName
        preposeDiploma: '',  // 前置学历证书图片
        oldGraduated: '', // 原毕业学校 input
        workCertificate: '', // 工作证明图片
        identityCardFront: '', // 身份证正面
        identityCardBack: '', // 身份证反面
       
      },
      isDisabled: false, // 是否禁用编辑
      birthDataShow: false, // 日期弹窗
      nationShow: false, // 民族
      residentShow: false, // 籍贯
      addressShow: false, // 通信地址
      politicalStatusShow: false, // 政治面貌
      ancestralNativeTypeShow: false, // 户口性质
    };
  },
  props: ['openId','formData','stepActive'],
  watch: {
    stepActive: {
      handler(newValue) {
        if (newValue == 1) {// 第二步
          this.initFn()
        }
      },
      deep: true,
      setImmediate: true
    },
  },
  methods: {
    initFn() {
      if (this.$store.state.userId) {
        this.dataForm.studentId = this.$store.state.userId
      }
      console.log('我的token', this.$store.state.token);
      if (this.$store.state.token) {
        this.getStudentInfoFn()
      }else {
        this.dataForm.openId = this.openId 
        this.dataForm.identityNum = localStorage.getItem('eleH5IdentityNum')
        this.dataForm.identityType = localStorage.getItem('eleH5IdentityType')
        console.log('identityType111:', this.dataForm.identityType);
   /*       getStudentInfo().then(res=>{
        if (res) {
          // console.log('res值是多少', res);
          Object.assign(this.dataForm,res)
        }
      }) */
        this.dataForm.specialtyId = localStorage.getItem('eleH5SpecialtyId')
        // 如果有身份证号，先计算性别和出生日期
        if (this.dataForm.identityNum && this.dataForm.identityType == 1) {
          this.byIdentityGetBirth(this.dataForm)
        }
        this.getByTypeRequest()
      }
    },
    getStudentInfoFn() {
      getStudentInfo().then(res=>{
        if (res) {
          this.isDisabled = !(
            res.approvalStatus == 0 || 
            res.approvalStatus == 1 ||
            res.approvalStatus == 3 ||
            res.approvalStatus == 6 ||
            res.approvalStatus == 9
          );
          // 先根据身份证号计算性别和出生日期，确保优先级最高
          if (res.identityNum) {
            this.byIdentityGetBirth(res)
          }
          console.log('res值是多少', res);
          Object.assign(this.dataForm,res)
          this.showDataFn(res)
        }else {
          this.getByTypeRequest()
        }
      })
    },
    // 通过身份证获取出生年月性别
    byIdentityGetBirth(data) {
      let idNo = data.identityNum
      //获取出生年月
      let str1 = idNo.substring(6, 10);
      let str2 = idNo.substring(10, 12);
      let str3 = idNo.substring(12, 14);
      // 性别
      if (str1 && str2 && str3) {
        data.birthDate = `${str1}-${str2}-${str3}`
        this.birthDateValue = new Date(str1,str2,str3)
      }
      // 0 男 1：女
      let num = idNo.charAt(16);
      data.gender = num % 2 == 0 ? '1' : '0'
    },

    // 数据回显
    async showDataFn(data) {
      // 有出生日期
      if (data.birthDate) {
        let strings = data.birthDate.split('-')
        this.birthDateValue = new Date(strings[0],strings[1],strings[2])
      }

      // 民族
      this.$getByType({code: 'ZGGMZMCDLMZMPXFH'}).then(res=>{
        this.mzList = res
        if (data.nation) {
          const nationItem = this.mzList.filter(item=>item.code == data.nation)
          this.$set(data,'nationName',nationItem && nationItem.length ? nationItem[0].name : '')
        }
      })
      // 政治面貌
      this.$getByType({code: 'ZZMM'}).then(res=>{
        this.zzmmList = res
        if (data.politicalStatus) {
          const politicalStatusItem = this.zzmmList.filter(item=>item.code == data.politicalStatus)
          this.$set(data,'politicalStatusName',politicalStatusItem && politicalStatusItem.length ? politicalStatusItem[0].name : '')
        }
      })
      // 户口性质
      this.$getByType({code: 'HKLB'}).then(res=>{
        this.hkxzList = res
        if (data.ancestralNativeType) {
          const ancestralNativeTypeItem = this.hkxzList.filter(item=>item.code == data.ancestralNativeType)
          this.$set(data,'ancestralNativeTypeName',ancestralNativeTypeItem && ancestralNativeTypeItem.length ? ancestralNativeTypeItem[0].name : '')
        }
      })
      // 籍贯 / 省市区
      admindivisionFirstList().then(res=>{
        this.provinceList = res
        data.communicationProvince && this.provinceCityAreaShow(data)
      })

      if (data.specialtyId) {
        getSpecialty().then(res=>{
          this.zymctsList = res
          let rs = this.zymctsList.filter(item=>item.id == data.specialtyId)
          this.isRequireWorkCertificate = Boolean(rs && rs.length)
        })
      }
    },
    // 省市区回显
    async provinceCityAreaShow(data) {
      // 省市区
      const communicationProvinceItem = this.provinceList.filter(item=>item.areaCode == data.communicationProvince)
      this.fieldValue = communicationProvinceItem[0].areaName
      // 市
      communicationProvinceItem[0].children = await admindivisionNextList(communicationProvinceItem[0].areaCode)// 市列表
      const CityItem = communicationProvinceItem[0].children.filter(item=>item.areaCode == data.communicationPrefecturalCity) 
      this.fieldValue = this.fieldValue + '/' + CityItem[0].areaName
      // 区域
      CityItem[0].children = await admindivisionNextList(CityItem[0].areaCode) // 区
      const areaItem = CityItem[0].children.filter(item=>item.areaCode == data.communicationGroundArea) 
      this.fieldValue = this.fieldValue + '/' + areaItem[0].areaName
      // 街道
      if (data.communicationStreet) {
        areaItem[0].children = await admindivisionNextList(areaItem[0].areaCode) // 区
        const streetItem = areaItem[0].children.filter(item=>item.areaCode == data.communicationStreet) 
        this.fieldValue = this.fieldValue + '/' + streetItem[0].areaName
      }
    },
    onSubmit() {
      return new Promise((resolve,reject)=>{
        if (this.isDisabled) {
          resolve()
          return
        }
        this.$refs.dataForms.validate().then(()=>{
          console.log('dataForm22', this.dataForm);
          // 只提取需要的字段提交，避免传入多余参数
          const submitData = {
            gender: this.dataForm.gender,
            birthDate: this.dataForm.birthDate,
            nation: this.dataForm.nation,
            nationName: this.dataForm.nationName,
            politicalStatus: this.dataForm.politicalStatus,
            politicalStatusName: this.dataForm.politicalStatusName,
            ancestralNativeType: this.dataForm.ancestralNativeType,
            ancestralNativeTypeName: this.dataForm.ancestralNativeTypeName,
            residentProvince: this.dataForm.residentProvince,
            residentPrefecturalCity: this.dataForm.residentPrefecturalCity,
            communicationProvince: this.dataForm.communicationProvince,
            communicationPrefecturalCity: this.dataForm.communicationPrefecturalCity,
            communicationGroundArea: this.dataForm.communicationGroundArea,
            communicationStreet: this.dataForm.communicationStreet,
            communicationDetailedAddress: this.dataForm.communicationDetailedAddress,
            preposeDiploma: this.dataForm.preposeDiploma,
            oldGraduated: this.dataForm.oldGraduated,
            workCertificate: this.dataForm.workCertificate,
            identityCardFront: this.dataForm.identityCardFront,
            identityCardBack: this.dataForm.identityCardBack,
            studentId: this.dataForm.studentId,
            identityNum: this.dataForm.identityNum,
            identityType: this.dataForm.identityType,
            specialtyId: this.dataForm.specialtyId,
            address: this.dataForm.address
          };
          saveData({...this.formData,...submitData}).then(res=>{
            resolve()
          })
        // 验证通过
        }).catch((err)=>{
          console.log('表单验证失败:', err);
          console.log('formData值:', this.formData);
          // 打印所有表单字段的值，方便排查
          console.log('当前表单数据:', JSON.stringify(this.dataForm));
          console.log('通信地址:', this.fieldValue);
          console.log('性别:', this.dataForm.gender);
          console.log('出生日期:', this.dataForm.birthDate);
          console.log('民族:', this.dataForm.nationName);
          console.log('政治面貌:', this.dataForm.politicalStatusName);
          console.log('户口性质:', this.dataForm.ancestralNativeTypeName);
          console.log('详细地址:', this.dataForm.communicationDetailedAddress);
          console.log('身份证正反面:', this.dataForm.identityCardBack);
          console.log('前置学历证书:', this.dataForm.preposeDiploma);
          console.log('毕业院校:', this.dataForm.oldGraduated);
          console.log('工作证明:', this.dataForm.workCertificate);
          console.log('个人证件照:', this.dataForm.photo);
          Toast({
            message: '请完善信息',
            position: 'top',
          });
        //验证失败
        })
      })
    },
    // 初始化
    getByTypeRequest() {
      // 名族
      this.$getByType({code: 'ZGGMZMCDLMZMPXFH'}).then(res=>{
        this.mzList = res
      })
      // 政治面貌
      this.$getByType({code: 'ZZMM'}).then(res=>{
        this.zzmmList = res
      })
      // 户口性质
      this.$getByType({code: 'HKLB'}).then(res=>{
        this.hkxzList = res
      })
      // 省份
      admindivisionFirstList().then(res=>{
        this.provinceList = res
      })
      getSpecialty().then(res=>{
        this.zymctsList = res
        let rs = this.zymctsList.filter(item=>item.id == this.dataForm.specialtyId)
        this.isRequireWorkCertificate = Boolean(rs && rs.length)
      })
      
    },
    // 选择日期
    onBirthDateConfirm(date) {
      this.dataForm.birthDate = this.zhbirth(date)
      this.birthDataShow = false
    },
    // 取消
    birthDataShowCancel() {
      this.birthDataShow = false
    },
    // 日期转换
    zhbirth(dateData) {
      let date = new Date(dateData)
      let y = date.getFullYear()
      let m = date.getMonth() + 1
      m = m < 10 ? ('0' + m) : m
      let d = date.getDate()
      d = d < 10 ? ('0' + d) : d
      const time =  y + '-' + m + '-' + d;
      return time

    },
    // 民族改变
    nationConfirm(e) {
      this.dataForm.nation = e.code
      this.dataForm.nationName = e.name
      this.nationShow = false
    },
    // 政治面貌改变
    politicalStatusConfirm(e) {
      this.dataForm.politicalStatus = e.code
      this.dataForm.politicalStatusName = e.name
      this.politicalStatusShow = false
    },
    // 户口性质改变
    ancestralNativeTypeConfirm(e) {
      this.dataForm.ancestralNativeType = e.code
      this.dataForm.ancestralNativeTypeName = e.name
      this.ancestralNativeTypeShow = false
    },
    // 省份改变
    /*
      省改变
      e: 时间e
      type: resident/籍贯  address/省市区街道
    */
    async addressChange(e,type) {
      if (type == 'resident') {
        if (e.tabIndex === 1) return
      }else {
        if (e.tabIndex === 3) return
      }
      const nextList = await admindivisionNextList(e.value)
      this.$set(e.selectedOptions[e.tabIndex],'children',nextList)
    },

    /*
      省改变结束
      e: {selectedOptions} 获取的值
      type: resident/籍贯  address/省市区街道
    */
    addressFinish({ selectedOptions },type) {
      if (type == 'resident') {// 籍贯
        if (selectedOptions.length == 2) {
          this.residentShow = false
        }
        selectedOptions.forEach((item,index)=>{
          if (index === 0) {
            this.dataForm.residentProvince = item.areaCode
          }else if (index === 1) {
            this.dataForm.residentPrefecturalCity = item.areaCode
          }
        })
        this.residentValue = selectedOptions.map((option) => option.areaName).join('/');

      }else if (type == 'address') { // 省市区街道
        if (selectedOptions.length === 4) {
          this.addressShow = false
        }
        selectedOptions.forEach((item,index)=>{
          if (index === 0) {
            this.dataForm.communicationProvince = item.areaCode
          }else if (index === 1) {
            this.dataForm.communicationPrefecturalCity = item.areaCode
          }else if (index === 2) {
            this.dataForm.communicationGroundArea = item.areaCode
          }else {
            this.dataForm.communicationStreet = item.areaCode
          }

        })
        this.fieldValue = selectedOptions.map((option) => option.areaName).join('/');
      }
      
    },

    // 证件照
    goPersonalPhoto() {
      this.$store.commit('setPhoto', this.dataForm.photo);
      this.$router.push({name: 'uploadTemp',query: {identityNum: this.dataForm.identityNum}})
    },

    // 身份证正反面
    goFrontBackIdCard() {
      this.$store.commit('setIdCard', {identityCardFront: this.dataForm.identityCardFront, identityCardBack: this.dataForm.identityCardBack});
      this.$router.push({name: 'idCard'})
    },

    // 前置学历证书电子版
    goPreposeDiploma() {
      this.$store.commit('setPreposeDiploma', this.dataForm.preposeDiploma)
      this.$router.push({name: 'diploma'})
    },
    //工作证明
    goWorkCertificate(){
      this.$store.commit('setWorkCertificate', this.dataForm.workCertificate)
      this.$router.push({name: 'work',query: {isRequireWorkCertificate:this.isRequireWorkCertificate}})
    }
  },
  activated() {
    const {idCard,preposeDiploma,workCertificate,photo} = this.$store.state
    if (idCard && Object.keys(idCard).length > 0) {
      Object.assign(this.dataForm,idCard)
    }
    // 只有当 Vuex 中的值不为空字符串时，才更新 dataForm
    // 避免从上传页面返回时，空值覆盖已有数据
    if (preposeDiploma) {
      this.dataForm.preposeDiploma = preposeDiploma
    }
    if (workCertificate) {
      this.dataForm.workCertificate = workCertificate
    }
    if (photo) {
      this.dataForm.photo = photo
    }
    this.$store.commit('setPhoto', '')
    this.$store.commit('setIdCard', {})
    this.$store.commit('setPreposeDiploma', '')
    this.$store.commit('setWorkCertificate', '')
  },

};
</script>

<style scoped>
.prompt {
  text-align: center;
  color: #c8c9cc;
  margin-bottom: 12px;
  font-size: 15px;
}
.van-cell::after {
  border-bottom: 1px solid #ddd;
}

::v-deep .van-field__label {
  display: flex;
  align-items: center;
}
::v-deep .van-cell__value--alone {
  text-align: right;
}
::v-deep .van-field__control {
  text-align: right;
}

.myCell {
  padding-right: 0;
  justify-content: flex-end;
}
/* 表单 */

.formData .modulesWrap {
  margin-bottom: 10px;
  border-radius: 10px;
  overflow: hidden;
  background-color: #fff;
}
.formData .cardWrap {
  background: #fff;
  padding: 18px 13px 10px;
}
.formData .cardTitle {
  padding-left: 10px;
  font-size: 20px;
  font-weight: 500;
  color: #333333;
  line-height: 20px;
  position: relative;
}
.formData .cardTitle::before {
  position: absolute;
  content: "";
  top: 50%;
  left: 0;
  width: 4px;
  height: 15px;
  background: #c1121e;
  border-radius: 2px;
  transform: translateY(-50%);
}
.formData .twoTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.formData .twoTitle img {
  width: 20px;
  margin-right: 10px;
}
.formData .twoTitle .ditu {
  display: flex;
  align-items: center;
}

.formData .degreeTip {
  color: red;
  padding: 0 10px;
}


.formData .tip {
  font-size: 13px;
  font-weight: 400;
  color: #999999;
  line-height: 26px;
  background-color: #fff;
  padding: 10px 0 10px 16px;
}

.formData .majorChange {
  box-sizing: border-box;
  display: flex;
  margin: 0 10px;
  height: 60px;
  border-radius: 5px;
  border: 1px solid #ddd;
  box-shadow: 00 10px 5px #aaa;
  margin-top: 10px;
  
}

.formData .majorChange .morenMajor {
  position: relative;
  flex: 1;
  text-align: center;
  line-height: 60px;
  font-size: 17px;
}
.formData .majorChange .morenMajor:nth-child(1)::after {
  position: absolute;
  top:20px;
  height:  20px;
  right:0;
  content: '';
  width:0;
  border-left: solid darkblue 1px;
}
.formData .majorChange .addMajor {
  color: red;
}

.next {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  position: fixed;
  z-index: 0;
  bottom: 0;
  width: 100%;
  height: 60px;
  padding: 0 10px;
  background-color: #fff;
}
.next .nextBtn {
  background-color: red;
  border: none;
  font-size: 18px;
  font-weight: bold;
}



/* .cardContent /deep/ .van-field__label {
  font-size: 15px;
  font-weight: 400;
  color: #333333;
}
.van-cell {
  flex: 1;
}
.phoneNumber {
  width: 90px;
  line-height: 40px;
  background: #d62d27;

  border-radius: 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 400;
  padding: 0;
  text-align: center;
}
.disabaled {
  background: #d5d5d5;
} */
/* .fbBox {
  padding-bottom: 10px;
}
.tipfb {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 28px;
  margin-left: 10px;
  flex: 1;
}
.alignCenter {
  align-items: center;
}
.flexStart {
  justify-content: flex-start;
}
.tipfb .subTip {
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 15px;
}
.tipImg {
  display: block;
  width: 16px;
}
.schoolWrap {
  border-radius: 10px;
}
.dizhi {
  display: block;
  width: 16px;
  margin-right: 10px;
}
.schoolSelect {
  flex: 1;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 20px;
}
.schoolSelect span {
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 18px;
}
.searchBox {
  border-radius: 5px;
  padding: 10px;
  font-size: 13px;
  line-height: 13px;
  flex: 1;
}
.serchBtn {
  width: 50px;
  text-align: center;
  border-radius: 5px;
  margin-left: 10px;
}
.noData {
  text-align: center;
  font-size: 12px;
  color: #999999;
}
.selectType {
  margin: 10px;
  font-size: 14px;
  line-height: 28px;
}
.selectType .checked {
  color: #d62d27;
}
.van-cell--required::before {
  left: -8px;
} */
</style>
